import React from 'react';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const AccCohortPricingSection = () => (
    <section className="lp-acc-sec">
        <div className="lp-acc-wrap">
            <span className="lp-acc-kicker" data-lp-reveal>Pricing for your company</span>
            <h2 className="lp-acc-h2" data-lp-reveal data-lp-delay="60">Fair for the cohort companies.</h2>

            <div className="lp-acc-pricing is-two">
                <div className="lp-acc-price-card is-pro" data-lp-reveal>
                    <div className="who">Cohort Company — Pro</div>
                    <div className="amt">£1,000<span className="unit">/yr</span></div>
                    <div className="per">Less than a day of a fractional CFO's time. Bulk cohort pricing available.</div>
                    <ul>
                        <li>Full Diligence Pack, AI pre-population</li>
                        <li>Corporate, financial &amp; technical reverse-diligence</li>
                        <li>Bronze / Silver / Gold certification</li>
                        <li>1-click InvestorMatch, 40+ VCs</li>
                    </ul>
                    <a className="lp-acc-btn lp-acc-btn--white" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Get Pro for your cohort</a>
                </div>

                <div className="lp-acc-price-card is-lite" data-lp-reveal data-lp-delay="90">
                    <div className="who">Application Triage</div>
                    <div className="amt">Free</div>
                    <div className="per">For every applicant, accepted or not — no commitment required</div>
                    <ul>
                        <li>20-minute structured overview</li>
                        <li>Readiness score before you read the deck</li>
                        <li>Warm handover if not accepted</li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
);

export default AccCohortPricingSection;
